import React from 'react';
import ReactTable from 'react-table';
import { JarvisWidget } from '../../../components';
import PropTypes from 'prop-types';
import moment from 'moment';

export default class IMCScorecard extends React.Component {
  static propTypes = {
    data: PropTypes.array,
    isLoading: PropTypes.bool,
    fetchData: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = { pageSize: 10, dateFilter: 'allTime' };
  }

  handleChange = event => {
    this.setState({ dateFilter: event.target.value });
    const params = this.getDateFilter(event.target.value);
    this.props.fetchData(params);
  };

  getData = () => {
    return this.props.data ? this.props.data : [];
  };

  getDateFilter = value => {
    switch (value) {
      case 'allTime':
        return {};
      case 'lastYear':
        return { from: moment().subtract(1, "years").startOf('year').format("YYYY-MM-DD"), to: moment().subtract(1, "years").endOf('year').format("YYYY-MM-DD") };
      case 'ytd':
        return { from: moment().startOf('year').format("YYYY-MM-DD") };
      case '180':
        return { from: moment().subtract(180, "days").format("YYYY-MM-DD") };
      case '90':
        return { from: moment().subtract(90, "days").format("YYYY-MM-DD") };
      case '60':
        return { from: moment().subtract(60, "days").format("YYYY-MM-DD") };
      case '30':
        return { from: moment().subtract(30, "days").format("YYYY-MM-DD") };
      default:
        return {};
    }
  };

  render() {
    const customOptionsFilterMethod = (filter, row) => {
      if (filter === '') {
        return true;
      }
      return (
        row.providerName &&
        row.providerName.toLowerCase().indexOf(filter.value.toLowerCase()) > -1
      );
    };
    return (
      <div className="row">
        <div className="col-md-12">
          <JarvisWidget
            color="white"
            fullscreenbutton={true}
            colorbutton={false}
            editbutton={false}
            togglebutton={false}
            deletebutton={false}
          >
            <header>
              <span className="widget-icon">
                {' '}
                <i className="fa fa-table" />{' '}
              </span>{' '}
              <h2>IMC Protocol Management</h2>
            </header>
            <div>
              <div className="widget-body no-padding">
                <div
                  className="form-inline padding-5"
                  style={{ borderBottom: '1px solid #eee' }}
                >
                  <div className="text-right">
                    <select
                      value={this.state.dateFilter}
                      onChange={this.handleChange}
                      className="form-control "
                    >
                      <option value="allTime">All Time</option>
                      <option value="lastYear">Last Year</option>
                      <option value="ytd">YTD</option>
                      <option value="180">Last 180 days</option>
                      <option value="90">Last 90 days</option>
                      <option value="60">Last 60 days</option>
                      <option value="30">Last 30 days</option>
                    </select>
                  </div>
                </div>
                <ReactTable
                  loading={this.props.isLoading}
                  data={this.getData()}
                  columns={[
                    {
                      Header: 'Provider Name',
                      id: 'providerName',
                      accessor: 'providerName',
                      filterMethod: (filter, row) =>
                        customOptionsFilterMethod(filter, row),
                    },
                    {
                      Header: 'Total Visit Notes',
                      id: 'totalVisitNotes',
                      accessor: 'totalVisitNotes',
                    },
                    {
                      Header: 'MSK Potential',
                      id: 'withPotentialMSK',
                      accessor: 'withPotentialMSK',
                    },
                    {
                      Header: 'Potential Breach',
                      id: 'withPotentialBreach',
                      accessor: 'withPotentialBreach',
                    },
                    {
                      Header: 'Resolved Breach',
                      id: 'withMSKFlagMarkedResolved',
                      accessor: 'withMSKFlagMarkedResolved',
                    },
                  ]}
                  defaultPageSize={this.state.pageSize}
                  onPageSizeChange={pageSize => this.setState({ pageSize })}
                  filterable
                  className="-striped -highlight"
                />
              </div>
            </div>
          </JarvisWidget>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/dashboard/components/IMCScorecard.js